import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateTransactionUser, TransactionUser, TransactionUserListResponse, TransactionUserQueryParams } from '@frontend/transaction/types';

export class TransactionUserClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTransactionUsers(queryParams?: ApiQueryParams<TransactionUserQueryParams>): Promise<TransactionUserListResponse> {
        return await this.apiPaginated<TransactionUserListResponse, TransactionUserQueryParams>(`${this.endpoint}/users`, queryParams);
    }

    public static async postTransactionUser(accountId: string, transactionId: string, createTransactionUser: CreateTransactionUser): Promise<TransactionUser> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/users`, createTransactionUser);
        return await this.handleResponse<TransactionUser>(response);
    }

    public static async fetchTransactionUser(accountId: string, transactionId: string, userId: string): Promise<TransactionUser> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/users/${userId}`);
        return await this.handleResponse<TransactionUser>(response);
    }

    public static async deleteTransactionUser(account_id: string, transactionId: string, userId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${account_id}/transactions/${transactionId}/users/${userId}`);
        return await this.handleVoidResponse(response);
    }
}
